import { RestrictionReason } from "../../../../../../Wrap/Models/Models/Account/Restrictions/RestrictionReason";
import {ProcessType} from "../../../../../Shared/IST/Resource/Content";

/**
 * check if need to block the wizard entry point with a popup message
 *
 * Top-up - Head Account status must = Active [Single Payment / Transfer,Add Regular Payment,Edit Regular Payment]
 * Buy - Cannot access where SubAccount status = Closing or Closed
 * Sell - Cannot access where SubAccount status = Closed. Internal users only can access where SubAccount status = Closing
 * Switch - Cannot access where SubAccount status = Closing or Closed
 * Withdrawal - Cannot access where SubAccount status = Closing or Closed. Internal users only can access where SubAccount status = Closing
 * 'What If' & 'No change' - Cannot access where SubAccount status = Closing or Closed
 *
 * @returns boolean => True for need block
 * story: SLP-92757
 */

export const SubAccountWizardLinkRestriction = (
    restrictionReasons: RestrictionReason[],
    processType: ProcessType
): boolean => {
    
    //Check if it is restriction type is "pension processing".
    let isPensionProcessing = false;
    if(restrictionReasons && restrictionReasons?.length > 0){
            restrictionReasons.map( x => 
                {
                    if(x.ReasonName == "Pension Processing"){
                        isPensionProcessing = true;
                        return;   
                    }
                });
    }

    if (
        [ProcessType.TakePensionBenefits, ProcessType.TopUpWithITFLS
            ,ProcessType.EditIncomeDrawdown,ProcessType.CancelRegularCrystallisation,
            ProcessType.OneoffIncomePayments,ProcessType.ConvertCappedToFlexi,ProcessType.GadReview,ProcessType.EditIncome
        ].includes(processType) && isPensionProcessing
    ) {
        return true;
    }
    
    return false;
}